// import external dependencies
import 'jquery';

// Import everything from autoload
import "./autoload/_bootstrap.js"

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import templateAboutUs from './routes/template-about-us';
import templateBrands from './routes/template-brands';
import taxBrands from './routes/tax-brands';
import singleCareer from './routes/single-career';
import singleRecipe from './routes/single-recipe';
import postTypeArchiveBlog from './routes/post-type-archive-blog';
import postTypeArchiveFaq from './routes/post-type-archive-faq';
import postTypeArchiveNews from './routes/post-type-archive-news';
import postTypeArchiveRecipe from './routes/post-type-archive-recipe';

import 'bootstrap-select';
import 'slick-carousel';
import 'jquery-touchswipe';
import '@fancyapps/fancybox';
import 'imagesloaded/imagesloaded.pkgd.js';

import 'jquery-bridget'
import Packery from 'packery';
$.bridget( 'packery', Packery, $ );

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,

  // Home page
  home,

  // About Us page, note the change from about-us to aboutUs.
  templateAboutUs,

  // Brands Page
  templateBrands,

  // Brands Single
  taxBrands,

  // Career Single
  singleCareer,

  // Recipe Single
  singleRecipe,

  // Blog Archive
  postTypeArchiveBlog,

  // News Archive
  postTypeArchiveFaq,

  // News Archive
  postTypeArchiveNews,

  // Recipes Archive
  postTypeArchiveRecipe,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js